import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { HardDrive, Link2, Unlink, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function DriveConnect() {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/drive/status").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const p = new URLSearchParams(window.location.search).get("drive");
    if (p) {
      p === "connected" ? toast.success("Google Drive connected") : toast.error("Google Drive connection failed — try again");
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);
  const connect = async () => {
    setBusy(true);
    try { const r = await api.get("/drive/connect"); window.location.href = r.data.authorization_url; }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not start"); setBusy(false); }
  };
  const disconnect = async () => {
    if (!window.confirm("Disconnect Google Drive? Private videos won't download until you connect again.")) return;
    await api.post("/drive/disconnect").catch(() => {});
    load();
  };
  if (!s) return null;
  const sa = user?.role === "super_admin";
  return (
    <div className="bg-[#111726] border border-[#1E293B] rounded-2xl p-5 mb-6 flex flex-wrap items-center gap-4" data-testid="drive-connect">
      <div className="w-10 h-10 rounded-xl bg-sky-500/10 border border-sky-500/30 flex items-center justify-center"><HardDrive className="w-5 h-5 text-sky-300" /></div>
      <div className="flex-1 min-w-[220px]">
        <div className="font-semibold">Private Google Drive videos</div>
        <div className="text-xs text-slate-500 mt-0.5" data-testid="drive-status-text">
          {!s.configured ? "Not set up yet — Google keys missing."
            : s.connected ? <>Connected as <span className="text-sky-300">{s.email || "Google account"}</span>. Ask the owner to share each video with this account as <b>Viewer</b> — no public link needed.</>
            : "Connect the Vivek AI Google account once, then videos shared with it (Viewer) can be processed."}
        </div>
      </div>
      {sa && s.configured && (s.connected
        ? <button data-testid="drive-disconnect-button" onClick={disconnect} className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-full border border-[#1E293B] text-slate-400 hover:text-rose-300 hover:border-rose-500/50 transition-colors"><Unlink className="w-3.5 h-3.5" /> Disconnect</button>
        : <button data-testid="drive-connect-button" onClick={connect} disabled={busy} className="inline-flex items-center gap-1.5 text-sm font-bold px-4 py-2.5 rounded-full bg-sky-400 text-slate-950 hover:bg-sky-300 transition-colors disabled:opacity-50">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Link2 className="w-4 h-4" />} Connect Google Drive</button>)}
    </div>
  );
}
